const message = {
  confirm: "confirm",
  cancel: "cancel",
  reset: "reset",
};

export default message;
